import { render } from "./CameraWifi.vue?vue&type=template&id=3117f7a7&scoped=true"
import script from "./CameraWifi.vue?vue&type=script&lang=js"
export * from "./CameraWifi.vue?vue&type=script&lang=js"

import "./CameraWifi.vue?vue&type=style&index=0&id=3117f7a7&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3117f7a7"]])

export default __exports__